import type { PlayerStatus } from '@sportninja/common/features/team/player/utils/playerStatus'
import type { StatusTone } from 'src/components/ts-components/StatusChip'

/**
 * How each roster Status reads: an active suspension is the alarm (red), an
 * injury needs attention (amber), and a suspension that has ended is history
 * (muted) — still worth seeing, but nothing to act on.
 */
export const PLAYER_STATUS_DISPLAY: Record<
  PlayerStatus['kind'],
  { labelKey: string; tone: StatusTone }
> = {
  suspended: { labelKey: 'common:suspended', tone: 'error' },
  injured: { labelKey: 'common:injured', tone: 'warn' },
  suspensionEnded: { labelKey: 'common:suspensionEnded', tone: 'muted' },
}
